/* Hook encargado de hacer la consulta a la base y 
traer las salenotes

Autor: Benjamín León
Fecha: 2024-08-25
*/
import { useState } from 'react'

import { customFetch } from '../utils/customFetch.ts'
import { SalenoteTasks } from '../interfaces/Salenote.ts'

import { makeUrlSalenotesTasks } from './connectionData.tsx'

const useSalenotesFetcher = () => {
  const [errorSalenotes, setErrorSalenotes] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  // Las notas de venta con tareas pendientes
  const fetchSalenotesTasks = async (organizationId: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlSalenotesTasks(organizationId)
      const data = await customFetch<SalenoteTasks[]>(apiUrl)
      setErrorSalenotes(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorSalenotes(err)
      } else {
        setErrorSalenotes(new Error('An unknown error occurred'))
      }

      return []
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorSalenotes, loading, fetchSalenotesTasks }
}

export default useSalenotesFetcher
